import {useAuthInfo, WithLoggedInAuthInfoProps} from "@propelauth/react";

import {CompanyType} from "../../models/company";
import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";
import React, {useContext, useState} from "react";
import {useToast} from "../ui/use-toast";
import {FullScopeModel} from "./ScopeModel";
import {Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage} from "../ui/form";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import {Input} from "../ui/input";
import {AutosizeTextarea} from "../ui/autoresizeTextArea";
import {Button} from "../ui/button";
// import InviteBidderByEmail from "../directory/InviteByEmail";
import {EdtSaveButtonToggle} from "../ui/EdtSaveButtonToggle";
import {ProjectContext} from "../../contexts/ProjectContext";
import InviteToQuickLink from "../qlink/QuickLinkInvites";
import CreateBidButton from "../navButtons/CreateBidButton";
import MessageBiddersDialog from "./developer/MessageBiddersDialog";


type ScopeFormProps = {
    editable?: boolean;
    create?: boolean;
    scope: FullScopeModel;
    editing?: boolean;
    onSave: (data: FullScopeModel) => void;
    //setIsEditing: (v: boolean) => void;
    onSubmit: (data: FullScopeModel) => void;
    // onCreateBid?: () => void;
    onInvite?: (e : string) => void;
    canInvite?: boolean;
    onCancel?: () => void;
    // rendered as a column to the right of the fields, inside this same card.
    aside?: React.ReactNode;
};

// type SaveEditButtonProps = {
//
//     setIsEditing: (x: boolean) => void;
//     onSave: () => void;
//     onCancel?: () => void;
// };

// function SaveEditButton(
//     {
//         setIsEditing,
//         onSave,
//         onCancel
//     }:SaveEditButtonProps) {
//     return <>
//         <Button
//             variant="outline"
//             onClick={() => {
//                 setIsEditing(false);
//                 if (onCancel) {
//                     onCancel()
//                 }
//             }}
//         >
//             Cancel
//         </Button>
//         <Button variant="outline" type="submit"
//                 onClick={() => onSave()}>
//             Save
//         </Button>
//     </>
// }

export function ScopeForm(
    {
        create,
        editable,
        scope,
        onSave,
        canInvite,
        onSubmit,
        onInvite,
        editing,
        onCancel,
        aside,
        ...props
    }: ScopeFormProps) {
    // const {accessToken} = useAuthInfo();
    // const {project_id, scope_id} = useParams<string>();
    const projectContext = useContext(ProjectContext);
    const {toast} = useToast();
    const [isEditing, setIsEditing] = useState<boolean>(editing as boolean);
    const canEdit = projectContext?.role === CompanyType.developer

    const form = useForm<FullScopeModel>({
        defaultValues: scope
    });

    const saveForm = () => {

    }

    return <Form {...form}>
        <form
            onSubmit={(e) => {
                e.preventDefault();
                form.handleSubmit(onSave);
            }}
        >
            <CardHeader>
                <CardTitle className="columns-2 flex justify-between">
                    <div>
                        Scope
                    </div>
                    {projectContext?.role === CompanyType.builder ?
                        <CreateBidButton />
                        :
                        <div className="align-middle">
                            {isEditing ? (
                                <>
                                    <Button
                                        variant="outline"
                                        onClick={() => {
                                            setIsEditing(false);
                                            if (onCancel) {  onCancel() }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="outline" type="submit"
                                            onClick={() => onSave(form.getValues())}>
                                        Save
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        onClick={() => setIsEditing(true)}>
                                        Edit
                                    </Button>
                                </>
                            )}
                             {canInvite ? <>
                                 <MessageBiddersDialog/>
                                <InviteToQuickLink onInvite={onInvite}/>


                             </> : <></>}
                        </div>
                    }
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="flex gap-6">
                <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-start gap-x-6 gap-y-2">
                    <FormField
                        control={form.control}
                        name="title"
                        render={({field}) => (
                            <FormItem className="grow basis-[16rem] min-w-0">
                                <FormLabel>Title</FormLabel>
                                <FormControl>
                                    <Input
                                        placeholder=""
                                        {...field}
                                        value={field.value}
                                        className="text-lg disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                        disabled={!isEditing}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                        }}
                                    />
                                </FormControl>
                                <FormDescription></FormDescription>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="description"
                        render={({field}) => (
                            // basis wider than the title, so a long description
                            // wraps onto its own line instead of squeezing it
                            <FormItem className="grow-[2] basis-[28rem] min-w-0">
                                <FormLabel>Description</FormLabel>
                                <FormControl>
                                    <AutosizeTextarea
                                        placeholder=""
                                        {...field}
                                        value={field.value}
                                        maxHeight={160}
                                        className="text-sm resize-none disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                        disabled={!isEditing}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                        }}
                                    />
                                </FormControl>
                                <FormDescription></FormDescription>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />
                </div>
                </div>

                {aside &&
                    <div className="w-1/3 shrink-0 border-l pl-6">{aside}</div>
                }
                </div>
            </CardContent>
        </form>
    </Form>

}